import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromMenuAlternative from "../reducers/menu-alternative.reducer";

export const menuDiscoveryState =
    createFeatureSelector<fromMenuAlternative.StateForDiscovery>(
        fromMenuAlternative.menuDiscoveryFeatureKey,
    );

export const selectDiscoveryMenuEntry = createSelector(
    menuDiscoveryState,
    (state: fromMenuAlternative.StateForDiscovery) => state.entry,
);

export const selectDiscoveryCategories = createSelector(
    menuDiscoveryState,
    (state: fromMenuAlternative.StateForDiscovery) => state.categories,
);

export const selectDiscoveryLinks = createSelector(
    menuDiscoveryState,
    (state: fromMenuAlternative.StateForDiscovery) => state.links,
);
